import "./naf-insurance-card.scss";
import { useState } from "react";
import {
  NAF_INSURANCE_BANNER_CTA,
  NAF_INSURANCE_BANNER_LINE1,
  NAF_INSURANCE_BANNER_LINE2,
} from "utilities/Constant";
import { trackFSInsuranceCardClick } from "utilities/full-story";
import { useInsuranceFullStoryTrackingProps } from "hooks/useInsuranceFullStoryTrackingProps";
import NafInsurancePanel from "pages/dashboard/advertisements/naf-insurance-panel/NafInsurancePanel";

export default function NafInsuranceCard() {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
  const insuranceTrackingProps = useInsuranceFullStoryTrackingProps();

  const handleLearnMoreClick = () => {
    trackFSInsuranceCardClick(insuranceTrackingProps);
    setIsInsuranceModalOpen(true);
  };

  return (
    <>
      <div className="naf-insurance-card">
        <div className="naf-insurance-card__body">
          <h6 className="naf-insurance-card__body-text paragraph-large-medium">{NAF_INSURANCE_BANNER_LINE1}</h6>
          <h6 className="naf-insurance-card__body-text label-large-regular">{NAF_INSURANCE_BANNER_LINE2}</h6>
          <div className="naf-insurance-card__btn-container">
            <button className="naf-insurance-card__btn label-medium-medium" onClick={handleLearnMoreClick} type="button">
              {NAF_INSURANCE_BANNER_CTA}
            </button>
          </div>
        </div>
      </div>
      {isInsuranceModalOpen && (
        <NafInsurancePanel
          onClose={() => setIsInsuranceModalOpen(false)}
        />
      )}
    </>
  );
}
